import { useState, useEffect } from 'react';
import { Button, Modal, Badge, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";

import plan_img from '../../../../images/subscription/plans.png';
import transaction from '../../../../images/subscription/transaction.png';
import payment_img from '../../../../images/subscription/payments.png';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addDays } from 'date-fns';

const RenewalSubscription = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [areaOption, setAreaOption] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`);
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if (area) {
            const preselected = areaOption.filter(option => option.value === area);
            console.log(preselected);
            setSelectedArea(preselected);
        }
    }, [area, areaOption]);

    const handleareachange = (selectedOption) => {
        setSelectedArea(selectedOption);
        setArea(selectedOption.value);
    };

    // delivery point dropdown
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    const [selecteddp, setselecteddp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`);
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.delivery_point,
                }));
                setdpoption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if (dp) {
            const preselected = dppoption.filter(option => option.value === dp);
            console.log(preselected);
            setselecteddp(preselected);
        }
    }, [dp, dppoption]);

    const handlechangedp = (selectedOption) => {
        setselecteddp(selectedOption);
        setDp(selectedOption.value);
    };


    // input datas
    const [timeline, setTimeline] = useState(null);
    const [address, setAddress] = useState('');
    const [description, setDescription] = useState('');
    const [packages, setPackage] = useState(null);
    const [subtotal, setsubtotal] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [alldays, setalldays] = useState(0);
    const [payment_process, setPayprocess] = useState(0);
    const [subscriberID, setSubscriberID] = useState(null);
    const [datas, setdatas] = useState([]);
    const [addresses, setAddressess] = useState([]);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [timelinerelation, settimeline] = useState([]);
    const [person_name, setpersonName] = useState('');
    const [delivery_contact, setdeliverycontact] = useState('');
    const [delivery_latitude, setdeliveryLatitude] = useState('');
    const [delivery_longitude, setdeliveryLongitude] = useState('');

    useEffect(() => {
        if (data) {
            setTimeline(data.timelinerelation);
            setAddress(data.address);
            setPackage(data.packagerelation);
            setalldays(data.timelinerelation.all_days);
            setSubscriberID(data.subscriber);
            settimeline(data.timelinerelation);
            setArea(data.area);
            setDp(data.delivery_point);
            setpersonName(data.delivery_person_name);
            setdeliverycontact(data.delivery_contact_number);
            setdeliveryLatitude(data.latitude);
            setdeliveryLongitude(data.longitude);
        }
    }, [data]);

    useEffect(() => {
        if (packages) {
            setsubtotal(parseFloat(packages.selling_amount));
            const gstValue = parseFloat(packages.selling_amount) * 0.05;
            setGst(gstValue);
            const total = parseFloat(packages.selling_amount) + gstValue;
            setTotalAmount(total);
        }
    }, [packages]);

    useEffect(() => {
        const fetchleaddetails = async () => {
            try {
                const response = await axios.get(`${baseURL}/subscriber/profile/${subscriberID}`);
                setdatas(response.data);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };
        if (subscriberID){
            fetchleaddetails();
        }
    }, [subscriberID]);

    useEffect(() => {
        if (datas?.multiple_address && Array.isArray(datas.multiple_address)) {
            const formatted = datas.multiple_address.map((item, index) => ({
            value: index,
            label: item.address,
            }));
            setAddressess(formatted);
        }
    }, [datas]);

    useEffect(() => {
        const matchedOption = addresses.find((item) => item.label === address);
        if (matchedOption) {
            setSelectedOption(matchedOption);
            setIsChecked(false); // If the address exists in the list, set isChecked to true
            setIsCheckboxChecked(false);
        } else {
            setIsChecked(true); // Otherwise, set isChecked to false
            setIsCheckboxChecked(true);
        }
    }, [address, addresses]); 

    const handleSelectChange = (selected) => {
        setSelectedOption(selected);
        setAddress(selected ? selected.label : '');  // Set address to the selected option's label
    };

    // start date
    const [startDate, setStartDate] = useState(null);
    const [startDateopt, setStartDateopt] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDateopt(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            console.log(formattedDate);
            setStartDate(formattedDate);
            if (timeline) {
                calculateEndDate(timeline, formattedDate, holidays);
            }
        } else {
            setStartDate(null);
        }
    };

    // due date
    const [duedate, setduedate] = useState(null);
    const [dueDateopt, setDueDateopt] = useState(null);
    const handledueDateChange = (date) => {
        setDueDateopt(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            console.log(formattedDate);
            setduedate(formattedDate);
        } else {
            setduedate(null);
        }
    };

    // payment mode dropdown
    const [paymentmode, setPaymode] = useState([]);
    const [transactionId, setTransactionId] = useState('');
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isVisible, setIsVisible] = useState(false);  
    useEffect(() => {
        const fetchpaymode = async () => {
            try {
            const response = await axios.get(`${baseURL}/paymentmode/getactive`);
            const formatted = response.data.map(item => ({
                value: item.sno,
                label: item.paymentmode_name,
                transaction_id: item.transaction_id,
            }));
            setPaymode(formatted);
            } catch (error) {
            console.error('Error fetching lead types:', error);
            }
        };

        fetchpaymode();
    }, []);

    // payment mode onchange
    const handlePaymentChange = (selectedOption) => {
        setSelectedPayment(selectedOption.value);
        setIsVisible(selectedOption?.transaction_id === 0); // Show field only if transaction_id is 0
    };

    // Holiday array
    const [holidays, setHolidays] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getholiday`);
                setHolidays(response.data.data);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // calculate end date
    const [endDate, setEndDate] = useState(null);
    const [endDateDisp, setEndDateDisp] = useState(null);
    const calculateEndDate = (timeline, startDate, holidays = []) => {
        const all_days = timeline.all_days;
        const days_count = timeline.days;
        let sunday, monday, tuesday, wednesday, thursday, friday, saturday;
        if ( all_days === 1) {
            sunday = timeline.sunday;
            monday = timeline.monday;
            tuesday = timeline.tuesday;
            wednesday = timeline.wednesday;
            thursday = timeline.thursday;
            friday = timeline.friday;
            saturday = timeline.saturday;
        } else {
            sunday = '0';
            monday = '0';
            tuesday = '0';
            wednesday = '0';
            thursday = '0';
            friday = '0';
            saturday = '0';
        }

        // Create a days array that represents the days of the week (0 = Sunday, 6 = Saturday)
        const daysOfWeek = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
        // console.log(daysOfWeek);
    
        let currentDate = moment(startDate);
        let validDaysCount = 0;
    
        // Loop until we've counted the required days (excluding invalid ones like Sundays)
        while (validDaysCount < days_count) {
            // console.log(validDaysCount, days_count);

            // Check if the current day is valid to count (i.e., its value is 1)
            const currentDayOfWeek = currentDate.day();
            // console.log(currentDate, currentDate.day());

            const currentDateStr = currentDate.format('YYYY-MM-DD');

            const isHoliday = holidays.includes(currentDateStr);
            const isValidDay = daysOfWeek[currentDayOfWeek] === '0';
            // console.log(currentDateStr, isHoliday, isValidDay);

            if (isValidDay && !isHoliday) {
                validDaysCount++;
            }
            
            // if (daysOfWeek[currentDayOfWeek] === '0') {
            //     validDaysCount++;
            // }
    
            // Move to the next day
            currentDate.add(1, 'days');
        }
        setEndDateDisp(currentDate.format('DD-MM-YYYY'));
        const endDate = currentDate.format('YYYY-MM-DD');
        // console.log(endDate);
        setEndDate(endDate);
        // return endDate;
    };
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [showInput, setShowInput] = useState(false);
    const [coupon, setCoupon] = useState('');

    const handleIconClick = () => {
        setShowInput(true);
    };

    const [couponamount, setcouponamount] = useState(0);
    const [couponID, setcouponId] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const handleApplyClick = () => {
        // You can handle the coupon logic here
        // console.log('Coupon applied:', coupon);

        if (!coupon) {
            setErrorMessage('Coupon Code is Required.');
            setTimeout(() => setErrorMessage(''), 5000);
            setShowInput(false);
            return;
        }

        const filter = {
            coupon_code: coupon || '',
            coupon_for: 1
        }

        axios.get(`${baseURL}/coupon/code`, {params: filter})
            .then(response => {
                // console.log(response);
                if (response.data.data) {
                    let datas = response.data.data;
                    setcouponId(datas.sno);
                    if (datas.coupon_type === 0){
                        // console.log(datas.coupon_value);
                        setcouponamount(parseFloat(datas.coupon_value));
                        setTotalAmount(parseFloat(subtotal + gst - parseFloat(datas.coupon_value)));
                    } else if (datas.coupon_type === 1) {
                        let percentage = parseFloat(datas.coupon_value);
                        let val = parseFloat(subtotal * parseFloat(percentage / 100));
                        // console.log(val);
                        setcouponamount(val);
                        setTotalAmount(parseFloat(subtotal + gst - val));
                    }
                } else {
                    setcouponamount(0);
                    setShowInput(false);
                    setErrorMessage('Coupon not valid or expired');
                    // Clear error message after 5 seconds
                    setTimeout(() => setErrorMessage(''), 5000);
                    setcouponId(null);
                    
                }
                setShowInput(false);
            })
            .catch(error => {
                setcouponamount(0);
                setShowInput(false);
                console.log('There was an error fetching the data!', error);
                setErrorMessage('Error fetching coupon. Please try again.');
                setTimeout(() => setErrorMessage(''), 5000);
                setcouponId(null);
            });
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!startDate) {
            newErrors.startd = "This Field is Required.";
        }
        
        if (!endDate) {
            newErrors.endd = "This Field is Required.";
        }

        if (!dp) {
            newErrors.dp = "This Field is Required.";
        }

        if (!area) {
            newErrors.area = "This Field is Required.";
        }

        if (!address) {
            newErrors.addrs = "This Field is Required.";
        }
        if (payment_process === 0) {
            if (!selectedPayment) {
                newErrors.paymode = "This Field is Required.";
            }
            
            if (isVisible) {
                if (!transactionId){
                    newErrors.trans = "This Field is Required.";
                }
            }
        } else if (payment_process === 1) {
            if (!duedate) {
                newErrors.dued = "This Field is Required.";
            }
        }

        if (!delivery_latitude) {
            newErrors.lat = "This Field is Required.";
        }

        if (!delivery_longitude) {
            newErrors.log = "This Field is Required.";
        } 

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            if (!validationErrors.valid){
                return;
            }
        }

        const postData = {
            branch_id: branch_id,
            lead: data.lead,
            subscriber: data.subscriber,
            lead_name: data.lead_name,
            lead_mobile_no: data.lead_mobile_no,
            lead_email_id: data.lead_email_id,
            delivery_person_name: person_name,
            delivery_contact_number: delivery_contact,
            latitude : delivery_latitude,
            longitude: delivery_longitude,
            address: address,
            product: data.product,
            timeline: data.timeline,
            package: data.package,
            product_amount: subtotal,
            product_count: 1,
            start_date: startDate,
            end_date: endDate,
            description: description,
            payment_process: payment_process,
            due_date: duedate,
            payment_mode: selectedPayment,
            transaction_id: transactionId,
            sub_total: subtotal,
            gst: gst,
            total_amount: totalAmount,
            renewal_id: data.sno,
            area: area,
            delivery_point: dp,
            coupon_id: couponID,
            coupon_amount: couponamount,
        }
        // console.log(postData);

        axios.post(`${baseURL}/subscription/renewal`, postData)
            .then(response => {
                refresh();
                onClose();
                toast.success("Subscription Renewed Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Renewal Failed");
            });
    };


    const [selectedOption, setSelectedOption] = useState(null);

    const cus_dt = () => {
        return { backgroundColor: '#e9ecef', marginTop: '0px', marginBottom: '0px' };
    };

    useEffect(() => {
        // Add 7 days to the current date
        const nextDate = new Date();
        nextDate.setDate(nextDate.getDate() + 7);
        setEndDate(nextDate);
    }, []);

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        setIsCheckboxChecked(e.target.checked);
    };

    const [paymentType, setPaymentType] = useState('immediate'); // default to Immediate
    // const [startDate, setStartDate] = useState(null); // due date value
    
    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Renewal Subscriptions</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* <form onSubmit={handleSubmit}> */}
                        <div className="row mb-1">
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_mobile_no}</label>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Product</label>
                                <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                                <label className='text-black fs-6 font-w500'>{data.timeline_name} ({data.timeline_days} Days)</label>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Days</label>
                                <label className='text-black fs-6 font-w500'>
                                    {timelinerelation.all_days === 0
                                        ? 'All'
                                        : [
                                            timelinerelation.monday === "0" && 'Mon',
                                            timelinerelation.tuesday === "0" && 'Tue',
                                            timelinerelation.wednesday === "0" && 'Wed',
                                            timelinerelation.thursday === "0" && 'Thu',
                                            timelinerelation.friday === "0" && 'Fri',
                                            timelinerelation.saturday === "0" && 'Sat',
                                            timelinerelation.sunday === "0" && 'Sun',
                                        ]
                                        .filter(Boolean)
                                        .join(', ')
                                    }
                                </label>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Amount</label>
                                <div>
                                    <Badge bg="success" className='text-white fs-6 py-0 px-1'>
                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                        <span>{subtotal}</span>
                                    </Badge>
                                </div>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Start Date'
                                        format="DD-MM-YYYY"
                                        minDate={addDays(new Date(), 1)} // Only allow dates from tomorrow onward
                                        value={startDateopt}
                                        onChange={handleStartDateChange}
                                    />
                                </div>
                                {errors.startd && <div className="text-danger fs-8 mt-1">{errors.startd}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">End Date</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text border-0 px-0 pt-0 pb-0 rounded-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select End Date'
                                        disabled
                                        value={endDateDisp}
                                        onChange={date => setEndDate(date)}
                                        format="DD-MM-YYYY"
                                        style={cus_dt()}
                                    />
                                </div>
                            </div>

                            {/* <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Customer Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Delivery Person" 
                                    maxLength={100}
                                    value={person_name}
                                    onChange={(e) => {
                                        const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        setpersonName(onlyAlphabets);
                                    }}
                                />
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Mobile Number<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Mobile Number" 
                                    maxLength={10}
                                    value={delivery_contact} 
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setdeliverycontact(onlyNums);
                                    }}
                                />
                            </div> */}

                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Latitude<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Latitude" 
                                    maxLength={100}
                                    value={delivery_latitude}
                                    onChange={(e) => {
                                        setdeliveryLatitude(e.target.value);
                                    }}
                                />
                                {errors.lat && <div className="text-danger fs-8 mt-1">{errors.lat}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Longitude<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Longitude" 
                                    maxLength={10}
                                    value={delivery_longitude}
                                    onChange={(e) => {
                                        setdeliveryLongitude(e.target.value);
                                    }}
                                />
                                {errors.log && <div className="text-danger fs-8 mt-1">{errors.log}</div>}
                            </div>

                            <div className="col-lg-12 mb-2 d-flex justify-content-between align-items-center">
                                <label className="text-black font-w500 fs-7">
                                    {isChecked ? 'Custom Address' : 'Address' }<span className="required">*</span>
                                </label>

                                <label className="text-black font-w500 fs-7 mb-2 d-flex justify-content-end">
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-2"
                                        id="customCheckBox1"
                                        checked={isCheckboxChecked}
                                    />
                                    Custom Address
                                </label>
                            </div>

                            {isChecked && (
                                <div className="col-lg-12 mb-3">
                                    <textarea className="form-control" placeholder="Enter Address"
                                        maxLength={250}
                                        value={address} 
                                        onChange={(e) => setAddress(formatName(e.target.value))} 
                                    />
                                    {errors.addrs && <div className="text-danger fs-8 mt-1">{errors.addrs}</div>}
                                </div>
                            )}
                            {!isChecked && (
                                <div className="col-lg-12 mb-3">
                                    <Select placeholder='Select Address'
                                        value={selectedOption}
                                        onChange={handleSelectChange}
                                        options={addresses}
                                    />
                                </div>
                            )}


                            <div className='col-lg-6 mb-3'>
                                <label className="text-black font-w500 fs-7">Area<span className="required">*</span></label>
                                <Select placeholder='Select Area'
                                    value={selectedArea}
                                    onChange={handleareachange}
                                    options={areaOption}
                                />
                                {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                            </div>
                            <div className='col-lg-6 mb-3'>
                                <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                                <Select placeholder='Select Delivery Point'
                                    value={selecteddp}
                                    onChange={handlechangedp}
                                    options={dppoption}
                                />
                                {errors.dp && <div className="text-danger fs-8 mt-1">{errors.dp}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Payment Process <span className="required">*</span></label>
                                <div className='mt-2'>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="product_type"
                                            value="immediate"
                                            checked={paymentType === 'immediate'}
                                            onChange={() => {
                                                setPaymentType('immediate');
                                                setPayprocess(0);
                                            }}
                                        />
                                        <label className="form-check-label fs-7">Immediate</label>
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="product_type"
                                            value="later"
                                            checked={paymentType === 'later'}
                                            onChange={() => {
                                                setPaymentType('later');
                                                setPayprocess(1);
                                            }}
                                        />
                                        <label className="form-check-label fs-7">Later</label>
                                    </div>
                                </div>
                            </div>
                            {paymentType === 'later' && (
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">
                                        Due Date<span className="required">*</span>
                                    </label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            placeholder='Select Start Date'
                                            value={dueDateopt}
                                            format="DD-MM-YYYY"
                                            onChange={handledueDateChange}
                                        />
                                    </div>
                                    {errors.dued && <div className="text-danger fs-8 mt-1">{errors.dued}</div>}
                                </div>
                            )}
                            <div className='row'>
                                {paymentType === 'immediate' && (
                                    <>
                                        <div className='col-lg-6'>
                                            <div className='text-center mb-4'>
                                                <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                                    <label className='mb-0'>Transaction Details</label>
                                                </div>
                                            </div>
                                            <div className='row mb-2'>
                                                <div className='col-lg-6 mb-4'>
                                                    <label className="text-black font-w500 fs-7">Payment Mode<span className="required">*</span></label>
                                                    <Select
                                                        placeholder="Select Mode"
                                                        options={paymentmode}
                                                        menuPlacement='top'
                                                        onChange={handlePaymentChange}
                                                    />
                                                    {errors.paymode && <div className="text-danger fs-8 mt-1">{errors.paymode}</div>}
                                                </div>
                                                {isVisible && (
                                                    <div className="col-lg-6 mb-4">
                                                        <label className="text-black font-w500 fs-7">Transaction ID<span className="required">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" placeholder="Enter Transaction ID" 
                                                            maxLength={500}
                                                            value={transactionId} 
                                                            onChange={(e) => setTransactionId(e.target.value)} 
                                                        />
                                                        {errors.trans && <div className="text-danger fs-8 mt-1 ">{errors.trans}</div>}
                                                    </div>
                                                )}
                                                <div className="col-lg-12 mb-4">
                                                    <label className="text-black font-w500 fs-7">Description</label>
                                                    <textarea className="form-control" placeholder="Enter Description" 
                                                        maxLength={255}
                                                        value={description} 
                                                        onChange={(e) => setDescription(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='text-center mb-4'>
                                                <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                                    <label className='mb-0'>Payments Details</label>
                                                </div>
                                            </div>
                                            <div className='row mb-2'>
                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <div className='text-black font-w500 fs-4'>Sub Total</div>
                                                    <div>
                                                        <label className='text-black font-w500 fs-3'>
                                                            <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                            <span>{subtotal}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                
                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <div className='text-black font-w500 fs-5 d-flex align-items-center'>
                                                        {!showInput ? (
                                                            <>
                                                                <label className='text-black font-w500 fs-5'>
                                                                    <span>Discount</span>
                                                                </label>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Apply Coupon</span></Tooltip>} >
                                                                    <span onClick={handleIconClick} className='ms-3' style={{ cursor: 'pointer' }}>
                                                                        {/* <svg
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="26"
                                                                            height="26"
                                                                            stroke="#5abf73"
                                                                        >
                                                                            <path d="M9 15L15 9" stroke="#5abf73" strokeWidth="1.5" strokeLinecap="round" />
                                                                            <path d="M15.5 14.5C15.5 15.0523 15.0523 15.5 14.5 15.5C13.9477 15.5 13.5 15.0523 13.5 14.5C13.5 13.9477 13.9477 13.5 14.5 13.5C15.0523 13.5 15.5 13.9477 15.5 14.5Z" fill="#5abf73" />
                                                                            <path d="M10.5 9.5C10.5 10.0523 10.0523 10.5 9.5 10.5C8.94772 10.5 8.5 10.0523 8.5 9.5C8.5 8.94772 8.94772 8.5 9.5 8.5C10.0523 8.5 10.5 8.94772 10.5 9.5Z" fill="#5abf73" />
                                                                            <path
                                                                                d="M14.0037 4H9.9963C6.21809 4 4.32899 4 3.15525 5.17157C2.27661 6.04858 2.0557 7.32572 2.00016 9.49444C1.99304 9.77248 2.22121 9.99467 2.49076 10.0652C3.35074 10.2901 3.98521 11.0711 3.98521 12C3.98521 12.9289 3.35074 13.7099 2.49076 13.9348C2.22121 14.0053 1.99304 14.2275 2.00016 14.5056C2.0557 16.6743 2.27661 17.9514 3.15525 18.8284M18 4.10041C19.3086 4.22774 20.1885 4.51654 20.8448 5.17157C21.7234 6.04858 21.9443 7.32572 21.9998 9.49444C22.007 9.77248 21.7788 9.99467 21.5092 10.0652C20.6493 10.2901 20.0148 11.0711 20.0148 12C20.0148 12.9289 20.6493 13.7099 21.5092 13.9348C21.7788 14.0053 22.007 14.2275 21.9998 14.5056C21.9443 16.6743 21.7234 17.9514 20.8448 18.8284C19.671 20 17.7819 20 14.0037 20H9.9963C8.82865 20 7.84143 20 7 19.9654"
                                                                                stroke="#5abf73"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                            />
                                                                        </svg> */}
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            height="50"
                                                                            id="coupon"
                                                                            enableBackground="new 0 0 512 512"
                                                                            viewBox="0 0 512 512"
                                                                        >
                                                                            <path
                                                                                fill="#ff4646"
                                                                                d="M400,368H48c0-17.673-14.327-32-32-32V112c17.673,0,32-14.327,32-32h352c0,17.673,14.327,32,32,32v224
                            C414.327,336,400,350.327,400,368z"
                                                                            />
                                                                            <path
                                                                                fill="#a5c3dc"
                                                                                d="M200,328H88c-8.837,0-16-7.163-16-16V200h144v112C216,320.837,208.837,328,200,328z"
                                                                            />
                                                                            <path
                                                                                fill="#e6e6eb"
                                                                                d="M120,328H72c-8.837,0-16-7.163-16-16V200h80v112C136,320.837,128.837,328,120,328z"
                                                                            />
                                                                            <rect width="40" height="16" x="56" y="200" fill="#a5c3dc" />
                                                                            <path
                                                                                fill="#a5c3dc"
                                                                                d="M48,160h176c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                                C40,163.582,43.582,160,48,160z"
                                                                            />
                                                                            <path
                                                                                fill="#e6e6eb"
                                                                                d="M48,160h88c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                                C40,163.582,43.582,160,48,160z"
                                                                            />
                                                                            <rect width="16" height="128" x="88" y="200" fill="#463c4b" />
                                                                            <rect width="16" height="16" x="88" y="200" fill="#32283c" />
                                                                            <rect width="16" height="40" x="80" y="160" fill="#463c4b" />
                                                                            <rect width="16" height="40" x="176" y="160" fill="#32283c" />
                                                                            <rect width="16" height="128" x="168" y="200" fill="#32283c" />
                                                                            <path
                                                                                fill="#32283c"
                                                                                d="M196,104c-15.033,0-29.168,5.854-39.8,16.485L136,140.686l-20.201-20.201C105.168,109.854,91.033,104,76,104
                            c-15.439,0-28,12.561-28,28s12.561,28,28,28h120c15.439,0,28-12.561,28-28S211.439,104,196,104z M76,144c-6.617,0-12-5.383-12-12
                            s5.383-12,12-12c10.76,0,20.877,4.19,28.485,11.799L116.687,144H76z M196,144h-40.687l12.2-12.201
                            C175.123,124.19,185.24,120,196,120c6.617,0,12,5.383,12,12S202.617,144,196,144z"
                                                                            />
                                                                            <g>
                                                                                <rect width="16" height="32" x="256" y="112" fill="#e6e6eb" />
                                                                                <rect width="16" height="16" x="256" y="80" fill="#e6e6eb" />
                                                                                <rect width="16" height="16" x="256" y="352" fill="#e6e6eb" />
                                                                                <rect width="16" height="32" x="256" y="160" fill="#e6e6eb" />
                                                                                <rect width="16" height="32" x="256" y="208" fill="#e6e6eb" />
                                                                                <rect width="16" height="32" x="256" y="256" fill="#e6e6eb" />
                                                                                <rect width="16" height="32" x="256" y="304" fill="#e6e6eb" />
                                                                            </g>
                                                                            <g>
                                                                                <path
                                                                                    fill="#e6e6eb"
                                                                                    d="M320,200c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S333.233,200,320,200z M320,168
                            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S324.411,168,320,168z"
                                                                                />
                                                                            </g>
                                                                            <g>
                                                                                <path
                                                                                    fill="#e6e6eb"
                                                                                    d="M384,296c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S397.233,296,384,296z M384,264
                            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S388.411,264,384,264z"
                                                                                />
                                                                            </g>
                                                                            <g>
                                                                                <path
                                                                                    fill="#e6e6eb"
                                                                                    d="M319.994,296.002c-1.203,0-2.423-0.272-3.572-0.846c-3.951-1.976-5.553-6.781-3.577-10.733l64-128
                            c1.977-3.952,6.78-5.552,10.733-3.578c3.951,1.976,5.553,6.781,3.577,10.733l-64,128
                            C325.754,294.381,322.929,296.002,319.994,296.002z"
                                                                                />
                                                                            </g>
                                                                        </svg>
                                                                    </span>
                                                                </OverlayTrigger>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <input className='form-control w-125px h-30px me-2'
                                                                    placeholder='Enter Coupon'
                                                                    value={coupon}
                                                                    onChange={(e) => setCoupon(e.target.value)}
                                                                />
                                                            </>
                                                        )}
                                                    </div>

                                                    <div className='text-black font-w500 fs-4 ms-5 align-items-center d-flex'>
                                                        {!showInput ? (
                                                            <>
                                                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                                            <label>{couponamount}</label>
                                                            </>
                                                        ) : (
                                                            <button className='btn btn-sm btn-secondary' onClick={handleApplyClick}>
                                                                Apply
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                                <div style={{ color: 'red'}}>
                                                    {errorMessage}
                                                </div>

                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <div className='text-black font-w500 fs-5'>
                                                        <lable className='text-black font-w500 fs-5'>GST</lable>
                                                        <lable className='text-danger font-w600 fs-5 ms-1'>( 5% )</lable>
                                                    </div>
                                                    <div className='text-black font-w500 fs-4'>
                                                        <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                                        <label className='text-black font-w500 fs-4'>{gst}</label>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <label className='text-black font-w500 fs-3'>Total Amount</label>
                                                    <div>
                                                        <label className='text-danger fw-bold fs-2'>
                                                            <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                            <span>{totalAmount}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                )}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            {/* <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Renewal Subscriptions<i className="fas fa-angle-double-right ms-2"></i></Link>
                        </div>
                    {/* </form> */}
                </div>
            </div>
        </Modal>
    );
};

export default RenewalSubscription;
